var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"name":"visor"}},[(this.$store.state.uivars.verComponenteVuePdfViewer)?_c('ComponenteVuePdfViewer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }